import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Card } from "@/components/ds/Card";

interface KpiProps {
  label: string;
  value: ReactNode;
  note?: ReactNode;
  /** Colour of the note: `ok` (default, e.g. "+12"), `err` or `muted`. */
  noteTone?: "ok" | "err" | "muted";
}

const NOTE_TONES = { ok: "text-ds-ok", err: "text-ds-err", muted: "text-ds-ink3" } as const;

/** KPI card: small label, large mono number, optional note. */
export function Kpi({ label, value, note, noteTone = "ok" }: KpiProps) {
  return (
    <Card className="px-3.5 py-3 font-ds">
      <span className="block text-xs text-ds-ink3">{label}</span>
      <b className="block font-ds-mono text-2xl font-bold tracking-[-0.01em] text-ds-ink">{value}</b>
      {note !== undefined && <span className={cn("block text-xs", NOTE_TONES[noteTone])}>{note}</span>}
    </Card>
  );
}
